import store from 'app/store';
import { FuseLoadable } from '@fuse';
import Split from '../../../../split';

const Index = {
    auth: ['admin', 'sub-admin', 'transport', 'sub-transport', 'processor', 'sub-processor'],
    routes: [
        {
            path: '/old/route-sessions/:date?',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                            return import('./raw-milk/admin/old/RouteSessionsApp');
                        case 'processor':
                        case 'sub-processor':
                            return import('./raw-milk/processor/old/ProcessorRouteSessionsApp');
                        default:
                            break;
                    }
                },
            }),
        },
        {
            path: '/route-sessions/:date?',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                            if (Split.getBooleanTreatment('can_use_new_route_session_table')) {
                                return import('./raw-milk/admin/RouteSessionsApp');
                            }
                            return import('./raw-milk/admin/old/RouteSessionsApp');
                        case 'processor':
                        case 'sub-processor':
                            if (Split.getBooleanTreatment('can_use_new_route_session_table')) {
                                return import('./raw-milk/processor/ProcessorRouteSessionsApp');
                            }
                            return import('./raw-milk/processor/old/ProcessorRouteSessionsApp');
                        default:
                            break;
                    }
                },
            }),
        },
        {
            path: '/cream-route-sessions/:date?',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                            return import('./cream/CreamRouteSessionApp');
                        case 'transport':
                        case 'sub-transport':
                            return import('./cream/CreamRouteSessionApp');
                        default:
                            break;
                    }
                },
            }),
        },
    ],
};

export default [Index];
